import HighlightButton, { HighlightButtonProps } from 'components/common/Buttons/HighlightButton';

export type ButtonProcProps = HighlightButtonProps & {
  onClick: (arg0: React.SyntheticEvent) => void;
  hidden?: boolean;
  variant?: string;
  size?: string;
  span?: boolean;
};

const ButtonProc = ({ firstProps, secondProps, ...props }: ButtonProcProps) => (
  <HighlightButton textAlign="center" {...props} />
);

export default ButtonProc;
